import BreakpointOnly from "./BreakpointOnly";
import { rtrim } from "../util/utils";

export default class SelectOrder extends BreakpointOnly {
  constructor(breakpoint, container) {
    super(breakpoint);

    this.$orderSelect = $('.orderby');
    this.$form = $('.woocommerce-ordering');
    this.container = container;
    this.defaultValue = this.$orderSelect.find('option:first-child').val();
    this.onOrderChange = this.onOrderChange.bind(this);
    this.openDropdown = this.openDropdown.bind(this);
    this.currentOrder = {
      orderby: this.$orderSelect.val(),
    };
    this.filtersApplied = false;

    this.breakpointChecker();
  }

  init(options)
  {
    let defaults = {
      theme: 'sort',
      minimumResultsForSearch: Infinity,
      width: '100%',
    };

    this.$orderSelect.selectWoo({...defaults, ...options});

    this.attachHandlers();
  }

  attachHandlers()
  {
    this.$orderSelect.on('change', this.onOrderChange);

    if(undefined !== this.container.el) {
      this.container.el.addEventListener('show.bs.offcanvas', this.onFilterOpen.bind(this));
      this.container.el.addEventListener('hide.bs.offcanvas', this.onFilterClose.bind(this));
    }

    const clearAll = document.querySelector('.btn-order-clear');

    if(clearAll) {
      clearAll.addEventListener('click', event => {
        event.preventDefault();
        this.resetToDefault();
      });
    }

    //Apply

    const applyAll = document.querySelector('.btn-order-apply');

    if( applyAll ) {
      applyAll.addEventListener('click', event => {
        event.preventDefault();
        //Only run filters when they was changed
        if(undefined !== this.tempOrder && JSON.stringify(this.currentOrder) !== JSON.stringify(this.tempOrder)) {
          this.runFilter();
        }
        this.filtersApplied = true;
        this.container.hide();
      })
    }
  }

  runFilter()
  {
    this.setQuery();
    document.body.dispatchEvent( new CustomEvent('palram_order_set'));
  }

  onFilterClose()
  {
    if(this.breakpoint.matches) {
      return;
    }

    if(this.filtersApplied) {
      this.filtersApplied = false;
      this.tempOrder = {};
      return;
    }

    if(undefined !== this.tempOrder && JSON.stringify(this.currentOrder) === JSON.stringify(this.tempOrder)) {
      this.tempOrder = {};
      return;
    }


    this.$orderSelect.off('change', this.onOrderChange);
    this.$orderSelect.val(this.tempOrder.orderby).trigger('change');
    this.setCurrentOrder(this.tempOrder.orderby);
    this.forceSelectDropdownItem();
    this.$orderSelect.on('change', this.onOrderChange);
    this.tempOrder = {};
  }

  onFilterOpen()
  {
    if(this.breakpoint.matches) {
      return;
    }

    this.tempOrder = Object.assign({}, this.currentOrder);
  }

  resetToDefault()
  {
    this.$orderSelect.off('change', this.onOrderChange);
    this.$orderSelect.val(this.defaultValue).trigger('change');
    this.forceSelectDropdownItem();
    this.setCurrentOrder(this.defaultValue);
    this.$orderSelect.on('change', this.onOrderChange);
  }

  forceSelectDropdownItem()
  {
    const index = this.$orderSelect.prop('selectedIndex')
    $('.select2-results__option').each(function(idx) {
      if(index === idx) {
        $(this)
          .addClass('select2-results__option--highlighted')
          .attr('data-selected', 'true');
      } else {
        $(this)
          .removeClass('select2-results__option--highlighted')
          .attr('data-selected', 'false');
      }
    });
  }

  onOrderChange(event)
  {
    this.setCurrentOrder($(event.target).val());

    if(this.breakpoint.matches) {
      this.runFilter();
    }
  }

  setCurrentOrder(orderby)
  {
    this.currentOrder = {orderby};
  }

  setQuery()
  {
    let uri = window.location.pathname;
    let oldQuery = window.location.search;
    let params = new URLSearchParams(oldQuery);
    if(params.has('orderby')) {
      params.set('orderby', this.getCurrentOrder());
    } else {
      params.append('orderby', this.getCurrentOrder())
    }

    if(params) {
      uri += `?${params}`;
    }

    uri = rtrim(uri, '?');

    window.history.replaceState({}, "", decodeURIComponent(uri));
  }

  getCurrentOrder()
  {
    return this.currentOrder.orderby;
  }

  openDropdown()
  {
    if(!this.$orderSelect.selectWoo('isOpen')) {
      this.$orderSelect.selectWoo('open');
    }
  }

  preventDefault(event)
  {
    event.preventDefault();
  }

  getForm()
  {
    return this.$form.get( 0 );
  }


  breakpointChecker() {

    if(!this.container.el) {
      return;
    }

    if(this.$orderSelect.hasClass('select2-hidden-accessible')) {
      this.$orderSelect.selectWoo('destroy');
    }

    this.init({
      closeOnSelect: this.breakpoint.matches,
      dropdownParent: !this.breakpoint.matches ? this.$form : $('body'),
    });

    if ( this.breakpoint.matches === true ) {
      this.container.el.removeEventListener('show.bs.offcanvas', this.openDropdown);
      this.$orderSelect
        .off("select2:closing", this.preventDefault)
        .off("select2:closed", this.openDropdown);
    } else {
      this.container.el.addEventListener('show.bs.offcanvas', this.openDropdown);
      this.$orderSelect
        .on("select2:closing", this.preventDefault)
        .on("select2:closed", this.openDropdown);
    }
  }
}
